import TrustLogos from './TrustLogos'
export default TrustLogos
export * from './TrustLogos'
